export const numberFormat = new Intl.NumberFormat().format;

export function NumberCell({ value }) {
    return <td style={{ textAlign: "right" }}>{value ? numberFormat(value) : "-"}</td>;
}
